<template>
	<div>
		<swiper class="swiper_tab05" :options="swiperOption_tab05" ref="mySwiper_tab05">
			<swiper-slide :key="index" v-for="(item,index) in list">
				<component :is="item.component"></component>
			</swiper-slide>
		</swiper>
	</div>
</template>

<script>
	//二级导航组件 --衍生
	import yanshengyq from '@/views/bookcity/yansheng_yq.vue';
	import yanshengca from '@/views/bookcity/yansheng_ca.vue';
	export default {
		props: ['swiperIndexFirstSe04'],
		data() {
			const that = this
			return {
				list: [{
						component: yanshengyq
					},
					{
						component: yanshengca
					}
				],
				mySwiper: null,
				//轮播图配置
				swiperOption_tab05: {
					spaceBetween: 0,
					centeredSlides: true,
					direction: 'horizontal',
					autoplay: false,
					loop: false,
					threshold : 50,
					pagination: {
						el: '.swiper-pagination',
						type: 'fraction',
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					observer: false,
					observeParents: false,
					// prevButton: ".swiper-button-prev",
					// nextButton: ".swiper-button-next",
					//滑动之后回调函数
					on: {
						slideChangeTransitionStart: function() {
							var swiper = that.$refs.mySwiper_tab05.$swiper;
							console.log(swiper.activeIndex, 'swiper.activeIndex')
							that.$emit('firSecondCateSlideTab04', swiper.activeIndex)
						},
					},
				},
			}
		},
		computed: {
			// 定义swiper，在下面就可以引用这个swiper了；
			swiper05: function() {
				return this.$refs.mySwiper_tab05.$swiper
			},
		},
		mounted() {
			this.swiper05.slideTo(localStorage.getItem('secondCategroy04') || 0);
		},
		watch: {
			swiperIndexFirstSe04(value, oldvalue) {
				// 接收 nav组件传过来的导航按钮索引，跳转到相应的内容区
				this.swiper05.slideTo(value, 0, false)
			}
		},
	}
</script>

<style>
</style>
